import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserObjectProvider } from './ObjectStore/UserObjectStore';
import { SnackbarProvider } from 'notistack';
import { createTheme, ThemeOptions, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { ja } from 'date-fns/locale';
import { SystemObjectProvider } from './ObjectStore/SystemObjectStore';


export const themeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: 'rgba(65,69,86,0.99)',
    },
    secondary: {
      main: '#388e3c',
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        h1: {
          fontSize: "1.3rem"
        },
        h2: {
          fontSize: "1.25rem"
        },
        h3: {
          fontSize: "1.1rem"
        }
      }
    }
  }
};

const theme = createTheme(themeOptions);

ReactDOM.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={ja}>
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={3}>
      <UserObjectProvider>
      <SystemObjectProvider>
        <App />
      </SystemObjectProvider>
      </UserObjectProvider>
      </SnackbarProvider>
    </ThemeProvider>
    </LocalizationProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
